/* eslint-disable camelcase */
import {
	getDeviceId,
	init,
	track,
} from '@amplitude/analytics-browser';
import eventList from '@zyro-inc/site-modules/constants/analyticsEventList';
import {
	MEDIA_MOBILE_BREAKPOINT,
	COOKIE_E2E_SKIP_AMPLITUDE,
} from '@zyro-inc/site-modules/constants/siteModulesConstants';
import { getCookie } from '@zyro-inc/site-modules/utils/cookies';

type LogEvent = {
  eventName: string;
  eventProperties?: Record<string, unknown>;
};

// Track initialization status
let isAmplitudeInitialized = false;

const initAmplitude = ({ siteId }: { siteId: string }) => {
	if (import.meta.env.DEV || getCookie(COOKIE_E2E_SKIP_AMPLITUDE) === 'true') {
		return;
	}

	const deviceId = getDeviceId();

	init(
		import.meta.env.VITE_AMPLITUDE_BROWSER_API_KEY,
		{
			serverUrl: import.meta.env.VITE_AMPLITUDE_ANALYTICS_URL,
			deviceId,
			defaultTracking: false,
			transport: 'beacon',
			flushIntervalMillis: 0,
			flushQueueSize: 1,
			userId: siteId,
		},
	);

	isAmplitudeInitialized = true;
};

const logEvent = async ({
	eventName,
	eventProperties = {},
}: LogEvent): Promise<void> => {
	if (!isAmplitudeInitialized) {
		return;
	}

	const device_mode = window.screen.width > MEDIA_MOBILE_BREAKPOINT ? 'desktop' : 'mobile';
	const verifiedEventName = eventList.getEvent(eventName)?.amplitude;

	if (!verifiedEventName) {
		console.error(`[Amplitude] \nEvent with name - ${eventName} not found in event list or wrong event object structure`);

		return;
	}

	const event = {
		device_mode,
		...eventProperties,
	};

	const isTestEnvironment = import.meta.env.NODE_ENV === 'test';

	if (!isTestEnvironment && (import.meta.env.DEV || getCookie(COOKIE_E2E_SKIP_AMPLITUDE) === 'true')) {
		// eslint-disable-next-line no-console
		console.info(`%c [Amplitude]: Sending event - ${verifiedEventName}`, 'color: skyblue; font-weight: bold;', event);

		return;
	}

	await track(verifiedEventName, event).promise;
};

export default {
	initAmplitude,
	logEvent,
};
